module.exports = __webpack_public_path__ + "static/media/DownloadWebsite.be237bd6.svg";